import { Box, Button, FormControl, IconButton, InputAdornment, TextField, Typography, useTheme } from '@mui/material'
import { useUserStore } from '../../store/user.store'
import { Icons } from '../../utils/utilities'
import React, { useState } from 'react'
import { toast } from 'react-toastify'

const Password = () => {

    const userStore = useUserStore()

    const [showPassword, setShowPassword] = useState( false )
    const [password, setPassword] = useState( '' )

    const { layout, palette } = useTheme()

    const save = async () => {
        const pattern = ``
        // const pattern = `^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z]).{8,32}$`
        if ( password.trim() && password.match( [pattern] ) ) {
            let payload = {
                "password": password
            }
            await userStore.updatePassword( payload )
            toast.success( "Password changed successfully!" )
            setPassword( "" )
        } else {
            toast.error( "Please provide a strong password" )
        }
    }

    return (
        <Box padding={layout.pagePadding} flexGrow={1} >
            <Box display="flex" flexDirection="column" gap={layout.sectionsGap}>
                <Box>
                    <Typography variant="h1" fontWeight="600" component="h1" fontSize="16px">Change Password</Typography>
                    <Typography variant="subtitle2" fontSize="12px" color='textSecondary'>Change this account password here</Typography>
                </Box>
                <Box display="flex" gap="20px" flexDirection="column">
                    <FormControl fullWidth>
                        <Typography htmlFor='new-password' variant='subtitle2' display="block" component="label" color={palette.form.labelColor}>New Password</Typography>
                        <TextField
                            placeholder='Enter you new strong password here.'
                            fullWidth
                            sx={{ width: "100%" }}
                            id="new-password"
                            size='small'
                            onChange={( e ) => setPassword( e.target.value )}
                            type={!showPassword ? 'text' : 'password'}
                            slotProps={{
                                input: {
                                    endAdornment:
                                        < InputAdornment position="end" >
                                            <IconButton
                                                aria-label="toggle password visibility"
                                                onClick={() => setShowPassword( !showPassword )}
                                                onMouseDown={( e ) => e.preventDefault()}
                                                edge="end"
                                            >
                                                {showPassword ? Icons.default.VisibilityOffIcon : Icons.default.VisibilityIcon}
                                            </IconButton>
                                        </InputAdornment>
                                }
                            }}
                        />
                    </FormControl>
                    <Button startIcon={Icons.default.CheckIcon} sx={{ textTransform: "capitalize", width: "fit-content" }} onClick={save} disableElevation variant='contained'>Save new password</Button>
                </Box>
            </Box>
        </Box>
    );
}

export default Password
